import { Coordinates } from './coordinates.model';

export interface Address extends Coordinates {
    label?: string;
    name?: string;
    city?: string;
    citycode?: string;
    country?: string;
}
